import React from 'react';
import { useContent } from '../context/ContentContext';
import { usePageMeta } from '../hooks/usePageMeta';
import {
  PageHeader,
  FeaturedArtistCard,
  AchievementsSection,
  ReleasesSection,
  AppleMusicSection,
  InstagramFeedSection,
  YouTubeSection,
  AboutElement45
} from '../components/element45/Element45Sections';

const Element45 = ({ setCurrentTrack }) => {
  usePageMeta(
    'Òlah Bliss | Element 45 | Rhodium Records',
    "Òlah Bliss — Element 45's flagship experimental artist. 8M+ streams, sold-out London shows. Listen on Spotify, Apple Music, and YouTube."
  );
  const { element45: artist } = useContent();

  const handlePlayRelease = (release) => {
    setCurrentTrack({
      title: release.title,
      artist: artist.name,
      artwork: release.artwork
    });
  };

  if (!artist) return <div className="min-h-screen bg-black" />;

  return (
    <div className="min-h-screen bg-black pt-24 pb-32">
      <div className="container mx-auto px-6">
        <PageHeader />
        <FeaturedArtistCard artist={artist} onPlay={handlePlayRelease} />
        <AchievementsSection achievements={artist.achievements} />
        <ReleasesSection artist={artist} />
        <AppleMusicSection />
        <InstagramFeedSection />
        <YouTubeSection />
        <AboutElement45 />
      </div>
    </div>
  );
};

export default Element45;
